import { useState, useEffect } from 'react';
import axios from 'axios';
import { tools as mockTools, categories as mockCategories } from '../data/mock';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const useTools = () => {
  const [tools, setTools] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTools = async () => {
      try {
        const response = await axios.get(`${API}/tools`);
        const apiTools = response.data;
        // Combine API tools with mock tools - API tools first, then mock tools
        // This ensures approved tools show up while keeping mock data as fallback
        const combinedTools = [...apiTools, ...mockTools];
        // Remove duplicates based on slug
        const uniqueTools = combinedTools.filter((tool, index, self) => 
          index === self.findIndex(t => t.slug === tool.slug)
        );
        setTools(uniqueTools);
      } catch (error) {
        console.error('Failed to fetch tools:', error);
        setTools(mockTools);
      } finally {
        setLoading(false);
      }
    };
    fetchTools();
  }, []);

  return { tools, loading, categories: mockCategories };
};

export const useBlogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get(`${API}/blogs`);
        setBlogs(response.data);
      } catch (error) {
        console.error('Failed to fetch blogs:', error);
        setBlogs([]);
      } finally {
        setLoading(false);
      }
    };
    fetchBlogs();
  }, []);

  return { blogs, loading };
};

export const useTool = (slug) => {
  const [tool, setTool] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTool = async () => {
      try {
        // First try API
        const response = await axios.get(`${API}/tools/${slug}`);
        setTool(response.data);
      } catch (error) {
        // Fallback to mock data
        const mockTool = mockTools.find(t => t.slug === slug);
        setTool(mockTool || null);
      } finally {
        setLoading(false);
      }
    };
    fetchTool();
  }, [slug]);

  return { tool, loading };
};

export const useBlog = (slug) => {
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await axios.get(`${API}/blogs/${slug}`);
        setBlog(response.data);
      } catch (error) {
        console.error('Failed to fetch blog:', error);
        setBlog(null);
      } finally {
        setLoading(false);
      }
    };
    fetchBlog();
  }, [slug]);

  return { blog, loading };
};

// Export categories for static use
export const categories = mockCategories;
